// F16/F20 GPS 位置情報取得ユーティリティ。
//
// 方針 (決定済み): 取得失敗/拒否時も打刻は許可し、警告のみ出す。
// そのため取得は best-effort とし、Promise でラップして失敗時は null を返す
// (例外を投げない)。打刻フローはこの結果を await し、座標があれば送信、
// なければ警告メッセージを表示したうえで打刻を続行する。

/** 取得した座標 (送信用に文字列化済み)。lat/lng はそのまま ClockIn/ClockOutInput に渡せる。 */
export interface CapturedPosition {
  latitude: string;
  longitude: string;
}

/**
 * 現在地を 1 回取得する。
 * - 取得成功: {@link CapturedPosition} を返す。
 * - geolocation 非対応 / 拒否 (PermissionDenied) / timeout / その他失敗: null を返す。
 *
 * 既定の timeout は 8 秒。打刻 UX を阻害しないよう、長く待たせない。
 */
export function captureCurrentPosition(
  opts: { timeoutMs?: number } = {},
): Promise<CapturedPosition | null> {
  const timeoutMs = opts.timeoutMs ?? 8_000;
  // SSR / jsdom など geolocation が無い環境では即座に null (取得失敗パス)。
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          latitude: String(pos.coords.latitude),
          longitude: String(pos.coords.longitude),
        });
      },
      () => {
        // PermissionDenied / PositionUnavailable / Timeout いずれも null に畳み込む。
        resolve(null);
      },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 },
    );
  });
}
